import React, { Component } from 'react'
import { withStyles } from "@material-ui/core/styles";
import { Box } from '@material-ui/core';
import InputAccountBank from '../../components/InputAccountBank';
import SelectItem from '../../components/SelectItem';
import CheckboxDefault from '../CheckboxDefault';
import { Search } from '@material-ui/icons/';
import { Button } from '@material-ui/core';

const styles = (theme) => ({
  main: {
    display: 'flex',
    [theme.breakpoints.down('sm')]: {
      margin: "10px 0 20px 0",
    }
  },
  boxFilters: {
    background: '#fff',
    padding: 15,
    width: '100%',
  },
  flex: {
    width: '100%',
    display: 'flex',
    alignItems: 'flex-end',
  },
  cleanFilter: {
    color: '#1874B9',
    fontSize: 14,
    textDecoration: 'underline',
    cursor: 'pointer'
  },
  searchBox: {
    background: '#1874B9',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: 158,
  },
  searchIcon: {
    color: '#fff',
    width: 45,
    height: 45,
  },
  divFiltroCodigo: {
    width: 'min-content',
    marginRight: '15px',
  },
})

const initialState = {
  loadingBanks: false,
  filterCodigoBanco: '',
  filterDebitoAutomatico: false,
  disableDdl: false,
  disableInputFied: false,
  banks: [],
  keyClear: 0,
}

class FilterBanks extends Component {
  constructor(props) {
    super(props);
    this.state = {...initialState, loadingBanks: this.props.loadingBanks}
  }

  componentDidMount() {
    this.setState({
      banks: this.props.ddlData
    })

    // let returnBanks = getBanks(4)
    // returnBanks.then(response => {
    //   this.setState({
    //     banks: response,
    //     loading: false,
    //   })
    // })
  }

  componentDidUpdate(prevProps){
    if(prevProps.ddlData !== this.props.ddlData){
      this.setState({
        banks: this.props.ddlData,
        loadingBanks: false
      })
    }
  }

  getBankTyped = (item) => {
    if(item !== ''){
      this.setState({
        filterCodigoBanco: item,
        disableDdl: true,
      })
    } else {
      this.setState({
        filterCodigoBanco: '',
        disableDdl: false,
      })
    }
  }

  getBankCode = (item) => {
    if(item !== ''){
      this.setState({
        filterCodigoBanco: item,
        disableInputFied: true,
      })
    } else {
      this.setState({
        filterCodigoBanco: '',
        disableInputFied: false,
      })
    }
  }

  getCheckboxSelected = (name, isChecked) => {
    this.setState({
      filterDebitoAutomatico: isChecked
    })
  }

  clearFilters = () => {
    this.setState({
      ...initialState,
      banks: this.props.ddlData,
      keyClear: this.state.keyClear + 1,
    })
    this.props.GetBanksFiltered(null)
  }

  handleSearchClick = () => {
    let filterParams = {
      filterCodigoBanco: parseInt(this.state.filterCodigoBanco),
      filterDebitoAutomatico: this.state.filterDebitoAutomatico
    } 
    this.props.GetBanksFiltered(filterParams)
  }

  render() {
    const { classes } = this.props;
    const { loadingBanks, disableInputFied, disableDdl } = this.state;

    return (
      <div className={classes.main} key={`filtro-bancos${this.state.keyClear}`}>
        <div className={classes.boxFilters}>
          <Box display="flex" justifyContent="flex-end">
            <span className={classes.cleanFilter} onClick={this.clearFilters}>Limpar Filtros</span>
          </Box>

          <div className={classes.flex}>
            <div id="divCodigoBanco" className={classes.divFiltroCodigo}>
              <InputAccountBank
                inputType={7}
                getBankTyped={this.getBankTyped}
                disabled={disableInputFied}
                codigoBancoSelecionado={this.state.filterCodigoBanco}
                clearAll={this.state.clearAll} />
            </div>

            <div id="divDdlBanco" className={classes.divFiltroCodigo}>
              <SelectItem
                typeSelect={4}
                getBankCode={this.getBankCode}
                banks={this.state.banks}
                disabled={disableDdl}
                clearAll={this.state.clearAll}
                codigoBancoSelecionado={this.state.filterCodigoBanco}
              />
            </div>

            <CheckboxDefault
              getCheckboxSelected={this.getCheckboxSelected}
              checkboxName={"Débito Automático"}
              clearAll={this.state.clearAll}
            />
          </div>
        </div>
        <div className={classes.searchBox}>
          <Button
            id="btnSubmitSearch"
            ref={this.searchButton}
            variant="primary"
            disabled={loadingBanks}
            onClick={!loadingBanks ? this.handleSearchClick : null}
            classes={{ root: classes.searchBox }}
          >
            <Search className={classes.searchIcon} />
          </Button>
        </div>

      </div>
    )
  }
}

export default withStyles(styles, { withTheme: true })(FilterBanks)
